/**
 * WebsiteServices — services grid (icon + title + description).
 * Icons resolved dynamically from lucide-react via name string in config.
 */
import * as Icons from 'lucide-react';

const FALLBACK_ICON = Icons.Wrench;

export default function WebsiteServices({ config }) {
  const services = Array.isArray(config.services) ? config.services : [];
  if (!services.length) return null;
  const primary = config.brand?.primary || '#0f4c81';
  const accent = config.brand?.accent || primary;

  return (
    <section id="services" className="py-20 lg:py-24 bg-white" data-testid="ws-services">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-2.5">
            What we do
          </p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-slate-900">
            Drywall services done right the first time.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => {
            const Icon = (s.icon && Icons[s.icon]) || FALLBACK_ICON;
            return (
              <div
                key={s.title}
                className="p-6 rounded-2xl border border-slate-200 bg-white hover:shadow-lg hover:border-slate-300 transition-all group"
                data-testid={`ws-service-${s.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:-translate-y-0.5"
                  style={{ backgroundColor: `${accent}1a`, color: accent }}
                >
                  <Icon size={20} strokeWidth={2} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-1.5">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
